<template>
  <b-modal
      id="profile-image-modal"
      centered
      :title="$t('pages.profile.personal.upload_photo')"
      title-class="font-18"
      size="sm"
      @ok="handleImage"
  >
    <croppa v-model="image"
            :width="275"
            :height="275"
            :placeholder="'Choose an image'"
            :show-remove-button="true"
            :initial-image="initial"
            @new-image-drawn="setImageMeta"
    ></croppa>
  </b-modal>
</template>

<script>
export default {
  name: "ProfileImageModal",
  props: ['initial'],
  data() {
    return {
      image: null,
      imgStr: null
    }
  },
  methods: {
    handleImage() {
      const imgStr = this.image.generateDataUrl()
      this.$emit('imgStr', imgStr)
    },
    async setImageMeta() {
      const meta = this.image.getMetadata();
      meta.orientation = 1;
      this.image.applyMetadata(meta);
    },

  }
}
</script>

<style scoped>
/deep/ .modal-body {
  align-self: center;
}
</style>